import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import ServicesList from './ServicesList';
import ThreadsList from './ThreadsList';
import ThreadDetail from './ThreadDetail';
import CityNotificationsList from './CityNotificationsList';
import SubscriptionSettings from './SubscriptionSettings';

const MainContent = () => {
  const { currentService, currentThread, showSettings } = useNotifications();

  // Render content based on navigation state
  const renderContent = () => {
    if (showSettings) {
      return <SubscriptionSettings />;
    } else if (currentThread) {
      return <ThreadDetail />;
    } else if (currentService) {
      // Check if it's a city service
      if (currentService.startsWith('[City] ')) {
        return <CityNotificationsList />;
      } else {
        // For business services, show threads
        return <ThreadsList />;
      }
    } else {
      return <ServicesList />;
    }
  };

  return (
    <main className="main-content">
      {renderContent()}
    </main>
  );
};

export default MainContent;